import { Dialog, Transition } from "@headlessui/react";
import React, { FC, Fragment, ReactNode } from "react";

import {
  ModalHead,
  SpSize,
  spOverlaySizeToClass,
} from "@/components/molecules/modals/Modal";

interface Props {
  isOpen: boolean;
  close: () => void;
  title: string;
  children: ReactNode;
  spSize?: SpSize;
}

export const BasicModal: FC<Props> = ({
  isOpen,
  close,
  title,
  children,
  spSize = "M",
}) => {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => close()}>
          <div className="fixed inset-0 bg-black/50" />
          <div className="overflow-y-auto fixed inset-0">
            <div
              className={`flex justify-center items-center p-4 min-h-full text-center ${spOverlaySizeToClass(
                spSize,
              )}`}
            >
              <Dialog.Panel className="overflow-hidden relative min-w-[50%] max-h-[90vh] text-left align-middle bg-white rounded-lg drop-shadow-[0_1px_5px_rgba(0,0,0,0.15)] transition-all lg:max-w-[50%]">
                <ModalHead title={title} onClickClose={close} />
                {children}
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
